import 
    {   basicProps, 
        observationProps,
        dayScheduleProps,
        documentVaultProps,
        employeeProps,
        serviceProps,
        serviceOptionProps, 
        consumableProps,
        extraBillingProps,
        paymentScheduleProps,
        guestFormProps, 
        default_list_prop, 
        expensesProps,
        centerPersonListProps} from './properties'

export const setEventProfileInfo = (state, payload) => {

    state.props.id = payload.id
    state.props.rescheduled = payload.rescheduled
    state.props.client = payload.client
    /*state.props.client.name = payload.client.name
    state.props.client.mobile_number = payload.client.mobile_number
    state.props.client.email = payload.client.email
    state.props.client.email = payload.client.email
    */
    state.props.center_person = payload.center_person
    state.props.center_person_dob = payload.center_person_dob
    state.props.center_person_age = payload.center_person_age
    
    state.props.budget.id = payload.budget.id
    state.props.budget.budget_number = payload.budget.budget_number
    state.props.budget.budget_date = payload.budget.budget_date
    state.props.consultant.id = payload.consultant.id
    state.props.consultant.name = payload.consultant.name
    state.props.event.id = payload.event.id
    state.props.event.name = payload.event.name
    state.props.event.start_at = payload.event.start_at
    state.props.event.end_at = payload.event.end_at
    state.props.event.duration = payload.event.duration
    state.props.event.event_date = payload.event.event_date
    state.props.event.fall_back_event_date = payload.event.fall_back_event_date
    state.props.event.reservation_date = payload.event.reservation_date
    state.props.salon = payload.salon
    state.props.menu.id = payload.menu.id
    state.props.catering.selected_menu_id = state.props.menu.id    
    state.props.menu.name = payload.menu.name
    state.props.menu.cost = payload.menu.cost
    state.props.total_bill = payload.total_bill
    state.props.total_balance = payload.total_balance
    state.props.records.observations = JSON.parse(payload.records.observations)
    state.props.records.day_schedule = JSON.parse(payload.records.day_schedule)
    state.props.records.documents = JSON.parse(payload.records.documents)
    //state.props.records.budgets = JSON.parse(payload.records.budgets)
    state.props.canceled = payload.canceled
    state.props.terms_link = payload.terms_link
    state.props.help_link = payload.help_link
    

    state.props.disable_day_scheduling = payload.disable_day_scheduling
    state.props.disable_catering_edit = payload.disable_catering_edit
    state.props.disable_table_plan_edit = payload.disable_table_plan_edit
    state.props.disable_guest_addition = payload.disable_guest_addition
    state.props.disable_table_cloth_selection = payload.disable_table_cloth_selection
    state.props.disable_cake_selection = payload.disable_cake_selection

    state.props.services_and_products.employees = JSON.parse(payload.services_and_products.employees)
    state.props.services_and_products.services = JSON.parse(payload.services_and_products.services)
    state.props.services_and_products.consumables = JSON.parse(payload.services_and_products.consumables)
    state.props.services_and_products.expenses = JSON.parse(payload.services_and_products.expenses)
    state.props.catering.food_menu_details = JSON.parse(payload.food_menu_details)
    
    state.props.billing_details.payment_plan = payload.billing_details.payment_plan //manual, short term, french method
    state.props.billing_details.interest_rate = payload.billing_details.interest_rate // interest per day
    state.props.billing_details.payment_schedule = JSON.parse(payload.billing_details.payment_schedule)
    state.props.billing_details.default_discount.amount = payload.billing_details.default_discount.amount
    state.props.billing_details.default_discount.notes = payload.billing_details.default_discount.notes
    state.props.billing_details.extra_billing = JSON.parse(payload.billing_details.extra_billing)
    state.props.billing_details.payment_history = payload.billing_details.payment_history
    state.props.billing_details.default_billing = JSON.parse(payload.billing_details.default_billing)

    state.props.guests.list = payload.guests.list.sort(function(a, b) {
        return a.guest_name.toLowerCase() > b.guest_name.toLowerCase() ? 1 : -1;
    });
    state.props.guests.default_count = payload.guests.default_count
    state.props.guests.all_guest_list = payload.guests.all_guest_list

    state.props.advance_percent = payload.advance_percent
    state.props.advance_due_days = payload.advance_due_days
    state.props.additional_clause = payload.additional_clause
    state.props.sign_percentage = payload.sign_percentage
    state.props.whatsapp_api_key = payload.whatsapp_api_key
    state.props.table_cloth_id = payload.table_cloth_id
    state.props.cake_id = payload.cake_id
    state.props.media_file_list = payload.media_file_list
    state.props.center_person_list = payload.center_person_list

    if(state.props.records.observations == null || state.props.records.observations.length == 0) {
        state.props.records.observations = [JSON.parse(JSON.stringify(observationProps))]
    } else {
        state.props.records.observations.forEach(element => {
            if(element.logs.length === 0) {
                element.entry_date = new Date().getFullYear()+'/'+(new Date().getMonth()+1)+'/'+(new Date().getDate()+1)
                element.client = true
            }
        })
    }  

    if(state.props.records.day_schedule == null || state.props.records.day_schedule.length == 0) {
        state.props.records.day_schedule = [JSON.parse(JSON.stringify(dayScheduleProps))]
        state.props.records.day_schedule[0].time_of_action = state.props.event.start_at        
    } else if(state.props.records.day_schedule.length == 1) {
        state.props.records.day_schedule[0].time_of_action = state.props.event.start_at        
    }
    
    if(state.props.records.day_schedule[0].time_of_action.length === 0) {
        state.props.records.day_schedule[0].time_of_action = state.props.event.start_at        
    }

    state.props.records.day_schedule.forEach(element => {
        if(!element.minutes) {
            element.minutes = 0
        }
    })
    if(state.props.records.documents == null || state.props.records.documents.length == 0) {
        state.props.records.documents = [JSON.parse(JSON.stringify(documentVaultProps))]
    }
    if(state.props.services_and_products.employees == null || state.props.services_and_products.employees.length == 0) {
        state.props.services_and_products.employees = [JSON.parse(JSON.stringify(employeeProps))]
    }
    
    if(state.props.services_and_products.services == null || state.props.services_and_products.services.length == 0) {
        state.props.services_and_products.services = [JSON.parse(JSON.stringify(serviceProps))]
    }
    if(state.props.services_and_products.consumables == null || state.props.services_and_products.consumables.length == 0) {
        state.props.services_and_products.consumables = [JSON.parse(JSON.stringify(consumableProps))]
    }
    if(state.props.services_and_products.expenses == null || state.props.services_and_products.expenses.length == 0) {
        state.props.services_and_products.expenses = [JSON.parse(JSON.stringify(expensesProps))]
    }
    
    if(state.props.billing_details.extra_billing == null || state.props.billing_details.extra_billing.length == 0) {
        state.props.billing_details.extra_billing = [JSON.parse(JSON.stringify(extraBillingProps))]
    }
    if(state.props.billing_details.payment_schedule == null || state.props.billing_details.payment_schedule.length == 0) {
        state.props.billing_details.payment_schedule = [JSON.parse(JSON.stringify(paymentScheduleProps))]
    }

    if(state.props.catering.food_menu_details == null) {
        state.props.catering.food_menu_details = []
    }

    state.props.client_selection_food_menu = payload.client_selection_food_menu
    state.props.client_selection_food_menu_allowed = parseInt(payload.client_selection_food_menu_allowed)

    if(state.props.center_person_list == null || state.props.center_person_list.length == 0) {
        state.props.center_person_list = [JSON.parse(JSON.stringify(centerPersonListProps))]

        state.props.center_person_list[0].name = state.props.center_person
        state.props.center_person_list[0].dob = state.props.center_person_dob
        state.props.center_person_list[0].age = state.props.center_person_age
        
    }

    let historical_halls = []
    try {
        historical_halls = JSON.parse(payload.historical_halls)
    } catch(err) {
       
    }
    
    let historical_menus = []
    try {
        historical_menus = JSON.parse(payload.historical_menus)
    } catch(err) {
       
    }
    
    state.props.historical_halls = historical_halls
    state.props.historical_menus = historical_menus
    
    if(state.props.billing_details.default_billing == null || state.props.billing_details.default_billing.length == 0) {
        
        state.props.billing_details.default_billing = []

        if(state.props.salon.id>0) {
            state.props.billing_details.default_billing.push(JSON.parse(JSON.stringify(default_list_prop)))
            let index = state.props.billing_details.default_billing.length-1
            state.props.billing_details.default_billing[index].key = 0
            state.props.billing_details.default_billing[index].billing_description = 'Salon '+state.props.salon.name
            state.props.billing_details.default_billing[index].qty = 1
            state.props.billing_details.default_billing[index].unit_price = state.props.salon.cost
            state.props.billing_details.default_billing[index].adjustment = 0
            state.props.billing_details.default_billing[index].final_unit_price = state.props.salon.cost
            state.props.billing_details.default_billing[index].amount = state.props.salon.cost
            state.props.billing_details.default_billing[index].editable = false    
        }    
        if(state.props.menu.id>0) {

            state.props.billing_details.default_billing.push(JSON.parse(JSON.stringify(default_list_prop)))
            let index = state.props.billing_details.default_billing.length-1
            state.props.billing_details.default_billing[index].key = 1
            state.props.billing_details.default_billing[index].billing_description = 'Menu '+state.props.menu.name
            state.props.billing_details.default_billing[index].qty = state.props.guests.default_count
            state.props.billing_details.default_billing[index].unit_price = state.props.menu.cost
            state.props.billing_details.default_billing[index].adjustment = 0
            state.props.billing_details.default_billing[index].final_unit_price = state.props.menu.cost
            state.props.billing_details.default_billing[index].amount = (state.props.billing_details.default_billing[index].final_unit_price * state.props.guests.default_count)
            state.props.billing_details.default_billing[index].editable = false
            
        }
        ///find service cost

        let list = state.props.services_and_products.services
        let serviceTotal = 0
        list.forEach(element => {
                
            try {
                let cost = parseFloat(element.service.sales_price)
                let profit = parseFloat(element.service.profit_percent)
                if(isNaN(cost) || isNaN(profit)) {

                } else {
                    serviceTotal = serviceTotal + (cost)
                }
            }
            catch(err) {
                    
            }
                    
        })
        if(serviceTotal>0) {

            state.props.billing_details.default_billing.push(JSON.parse(JSON.stringify(default_list_prop)))
            let index = state.props.billing_details.default_billing.length-1
            state.props.billing_details.default_billing[index].key = 2
            state.props.billing_details.default_billing[index].billing_description = 'Servicios'
            state.props.billing_details.default_billing[index].qty = 1
            state.props.billing_details.default_billing[index].unit_price = serviceTotal
            state.props.billing_details.default_billing[index].adjustment = 0
            state.props.billing_details.default_billing[index].final_unit_price = serviceTotal
            state.props.billing_details.default_billing[index].amount = serviceTotal
            state.props.billing_details.default_billing[index].editable = false    
        }
        //// end
        if(state.props.billing_details.default_discount.amount>0) {

            state.props.billing_details.default_billing.push(JSON.parse(JSON.stringify(default_list_prop)))
            let index = state.props.billing_details.default_billing.length-1
            state.props.billing_details.default_billing[index].key = 3
            state.props.billing_details.default_billing[index].billing_description = state.props.billing_details.default_discount.notes
            state.props.billing_details.default_billing[index].qty = 1
            state.props.billing_details.default_billing[index].unit_price = -state.props.billing_details.default_discount.amount
            state.props.billing_details.default_billing[index].adjustment = 0
            state.props.billing_details.default_billing[index].final_unit_price = -state.props.billing_details.default_discount.amount
            state.props.billing_details.default_billing[index].amount = -state.props.billing_details.default_discount.amount
            state.props.billing_details.default_billing[index].editable = false    
        }

        if(state.props.billing_details.payment_plan == 1) {

            let totalInterest = state.props.billing_details.payment_schedule.forEach(element => {
                if(!isNaN(parseFloat(element.interest))) {
                    totalInterest = totalInterest + parseFloat(element.interest)
                }                
            });

            state.props.billing_details.default_billing.push(JSON.parse(JSON.stringify(default_list_prop)))
            let index = state.props.billing_details.default_billing.length-1
            state.props.billing_details.default_billing[index].key = 4
            state.props.billing_details.default_billing[index].billing_description = 'Interesar'
            state.props.billing_details.default_billing[index].qty = 1
            state.props.billing_details.default_billing[index].unit_price = totalInterest
            state.props.billing_details.default_billing[index].adjustment = 0
            state.props.billing_details.default_billing[index].final_unit_price = totalInterest
            state.props.billing_details.default_billing[index].amount = totalInterest
            state.props.billing_details.default_billing[index].editable = false    
        }
        
    }
    
}

export const setEventList = (state, payload) => {
    
    let records = payload.response
    
    if(payload.search_query.length>0) {
        state.list = records
    } else if(payload.fresh_search) {
        state.list = records
    } else {
        records.forEach(element => {
            state.list.push(element)
        })
    }
    
    state.total_rows = payload.total_rows
    state.start_row = parseInt(payload.start_row) + parseInt(payload.end_row)
    
}

export const setEventId = (state, payload) => {
    state.props.id = payload
}

export const setEventRecordObservations = state => {
    state.props.records.observations.push(JSON.parse(JSON.stringify(observationProps)))

    let indexNum = 0
    state.props.records.observations.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
    
}

export const setEventRecordDaySchedules = state => {
    state.props.records.day_schedule.push(JSON.parse(JSON.stringify(dayScheduleProps)))

    let indexNum = 0
    state.props.records.day_schedule.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
    
}

export const setEventRecordDocuments = state => {
    state.props.records.documents.push(JSON.parse(JSON.stringify(documentVaultProps)))

    let indexNum = 0
    state.props.records.documents.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
    
}

export const setEventServicesAndProductsEmployees = state => {
    state.props.services_and_products.employees.push(JSON.parse(JSON.stringify(employeeProps)))

    let indexNum = 0
    state.props.services_and_products.employees.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
}

export const setEventServicesAndProductsExpenses = state => {
    state.props.services_and_products.expenses.push(JSON.parse(JSON.stringify(expensesProps)))

    let indexNum = 0
    state.props.services_and_products.expenses.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
}

export const setEventServicesAndProductsServices = state => {

    if(state.props.services_and_products.services == null) {
        state.props.services_and_products.services = [JSON.parse(JSON.stringify(serviceProps))]
    } else {
        state.props.services_and_products.services.push(JSON.parse(JSON.stringify(serviceProps)))
    }
    

    let indexNum = 0
    state.props.services_and_products.services.forEach(element => {
        element.key = indexNum
        indexNum ++
    })

    let list = state.props.services_and_products.services
        let serviceTotal = 0
        list.forEach(element => {
                
            try {
                let cost = parseFloat(element.service.sales_price)
                let profit = parseFloat(element.service.profit_percent)
                if(isNaN(cost) || isNaN(profit)) {

                } else {
                    serviceTotal = serviceTotal + ((cost/(100+profit))*100)
                }
            }
            catch(err) {
                    
            }
                    
        })
        
}

export const setEventServicesAndProductsConsumables = state => {
    state.props.services_and_products.consumables.push(JSON.parse(JSON.stringify(consumableProps)))

    let indexNum = 0
    state.props.services_and_products.consumables.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
}

export const setEventBillingDetailsExtraBilling = state => {
    state.props.billing_details.extra_billing.push(JSON.parse(JSON.stringify(extraBillingProps)))

    let indexNum = 0
    state.props.billing_details.extra_billing.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
}

export const setEventBillingDetailsPaymentSchedule = (state, payload) => {
    
    /// calculate total scheduled
    let total = 0
    state.props.billing_details.payment_schedule.forEach(element => {
        total = total + parseFloat(element.amount)
    })
    /// end

    state.props.billing_details.payment_schedule.push(JSON.parse(JSON.stringify(paymentScheduleProps)))

    let myDate = new Date(payload.date);

    let result1 = myDate

    if(parseInt(payload.initial) === 1) {
        //result1 = myDate
    } else {
        //result1 = myDate.setMonth(myDate.getMonth()+1)    
    }

    let length = (state.props.billing_details.payment_schedule.length - 1)

    state.props.billing_details.payment_schedule[length].schedule_date = payload.date    
    state.props.billing_details.payment_schedule[length].amount = state.props.billing_details.payment_plan == 0 ? (state.props.total_balance - total) : payload.amount
    state.props.billing_details.payment_schedule[length].description = "Cuota-"+(length+1)

    state.props.billing_details.payment_schedule[length].capital = payload.capital
    state.props.billing_details.payment_schedule[length].amortization = payload.amortization
    state.props.billing_details.payment_schedule[length].interest = payload.interest

    let indexNum = 0
    state.props.billing_details.payment_schedule.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
}

export const resetEventBillingDetailsPaymentSchedule = state => {

    let indexNum = 0
    state.props.billing_details.payment_schedule.forEach(element => {
        element.key = indexNum
        indexNum ++
    })

}

export const  setEventGuestForm = (state, payload) => {
    state.props.guests.guest_form = payload
}

export const setEventGuestPlusOneList = (state, payload) => {
    state.props.guests.plus_one_list = payload
    state.props.guests.plus_one_list.push(JSON.parse(JSON.stringify(guestFormProps)))
    
}

export const resetGuestForm = state => {
    state.props.guests.guest_form = JSON.parse(JSON.stringify(guestFormProps))
}

export const convertBudgetToEvent = (state, payload) => {
    
    let budget_data = payload.budget_data

    state.props.client.id = budget_data.client.id
    state.props.client.name = budget_data.client.name
    

    state.props.budget.id = budget_data.id
    state.props.budget.budget_number = budget_data.budget_number
    state.props.budget.budget_date = budget_data.budget_date
    
    state.props.consultant.id = budget_data.consultant_id
    state.props.consultant.name = budget_data.employee_name

    state.props.event.id = budget_data.event_type
    state.props.event.name = budget_data.event_name
    state.props.event.name = budget_data.event_name
    state.props.event.event_date = budget_data.event_date

    state.props.salon.id = budget_data.hall.id
    state.props.salon.name = budget_data.hall.name
    state.props.salon.cost = budget_data.hall.cost
    state.props.salon.max_round_tables = budget_data.hall.max_round_tables

    state.props.menu.id = budget_data.menu.id
    state.props.menu.name = budget_data.menu.name
    state.props.menu.cost = budget_data.menu.cost

    let budgetServiceSelection = []
    
    try {
        budgetServiceSelection = JSON.parse(budget_data.services)
    } catch(err) {
        budgetServiceSelection = budget_data.services
    }
    
    let historical_halls = []
    try {
        historical_halls = JSON.parse(budget_data.existing_halls)
    } catch(err) {
       
    }
    
    let historical_menus = []
    try {
        historical_menus = JSON.parse(budget_data.existing_menus)
    } catch(err) {
       
    }
    
    state.props.historical_halls = historical_halls
    state.props.historical_menus = historical_menus
    
    let originalServices = (payload.original_service_list)
    let eventServices = []

    let index = 0
    if(budgetServiceSelection == null || budgetServiceSelection.length == 0) {
    } else {
        
    budgetServiceSelection.forEach(element => {
        let originalServiceIndex = originalServices.findIndex((t) => element.service.id === t.id)
        if(originalServiceIndex>=0) {
            eventServices.push({
                key: index,
                service: 
                    {
                        id: element.service.id, 
                        service_title: element.service.service_title, 
                        sales_price: element.service.sales_price, 
                        profit_percent: originalServices[originalServiceIndex].profit_percent,
                        original_service_options: JSON.parse(originalServices[originalServiceIndex].service_options), 
                        selected_service_options: (element.service.selected_service_options),
                        service_providers: JSON.parse(originalServices[originalServiceIndex].supplier_names)
                    },
                service_options:  [JSON.parse(JSON.stringify(serviceOptionProps))],
                service_provider_id: 0,
                notify: false    
            })
            index ++
        }
    })
    }

    state.props.services_and_products.services = eventServices

    state.props.billing_details.default_discount.amount = budget_data.total.discount.amount
    state.props.billing_details.default_discount.notes = budget_data.total.discount.notes
    state.props.billing_details.interest_rate = budget_data.total.interest_rate

    state.props.guests.default_count = budget_data.guest_count
    
        state.props.billing_details.default_billing = []
        if(state.props.salon.id>0) {
            state.props.billing_details.default_billing.push(JSON.parse(JSON.stringify(default_list_prop)))
            let index = state.props.billing_details.default_billing.length-1
            state.props.billing_details.default_billing[index].key = 0
            state.props.billing_details.default_billing[index].billing_description = 'Salon '+state.props.salon.name
            state.props.billing_details.default_billing[index].qty = 1
            state.props.billing_details.default_billing[index].unit_price = state.props.salon.cost
            state.props.billing_details.default_billing[index].adjustment = 0
            state.props.billing_details.default_billing[index].final_unit_price = state.props.salon.cost
            state.props.billing_details.default_billing[index].amount = state.props.salon.cost
            state.props.billing_details.default_billing[index].editable = false    
        }    
        if(state.props.menu.id>0) {

            state.props.billing_details.default_billing.push(JSON.parse(JSON.stringify(default_list_prop)))
            let index = state.props.billing_details.default_billing.length-1
            state.props.billing_details.default_billing[index].key = 1
            state.props.billing_details.default_billing[index].billing_description = 'Menu '+state.props.menu.name
            state.props.billing_details.default_billing[index].qty = state.props.guests.default_count
            state.props.billing_details.default_billing[index].unit_price = state.props.menu.cost
            state.props.billing_details.default_billing[index].adjustment = 0
            state.props.billing_details.default_billing[index].final_unit_price = state.props.menu.cost
            state.props.billing_details.default_billing[index].amount = (state.props.billing_details.default_billing[index].final_unit_price * state.props.guests.default_count)
            state.props.billing_details.default_billing[index].editable = false
            
        }
        ///find service cost

        let list = state.props.services_and_products.services
        let serviceTotal = 0
        list.forEach(element => {
                
            try {
                let cost = parseFloat(element.service.sales_price)
                let profit = parseFloat(element.service.profit_percent)
                if(isNaN(cost) || isNaN(profit)) {

                } else {
                    serviceTotal = serviceTotal + (cost)
                }
            }
            catch(err) {
                    
            }
                    
        })
        if(serviceTotal>0) {

            state.props.billing_details.default_billing.push(JSON.parse(JSON.stringify(default_list_prop)))
            let index = state.props.billing_details.default_billing.length-1
            state.props.billing_details.default_billing[index].key = 2
            state.props.billing_details.default_billing[index].billing_description = 'Servicios'
            state.props.billing_details.default_billing[index].qty = 1
            state.props.billing_details.default_billing[index].unit_price = serviceTotal
            state.props.billing_details.default_billing[index].adjustment = 0
            state.props.billing_details.default_billing[index].final_unit_price = serviceTotal
            state.props.billing_details.default_billing[index].amount = serviceTotal
            state.props.billing_details.default_billing[index].editable = false    
        }
        //// end
        if(state.props.billing_details.default_discount.amount>0) {

            state.props.billing_details.default_billing.push(JSON.parse(JSON.stringify(default_list_prop)))
            let index = state.props.billing_details.default_billing.length-1
            state.props.billing_details.default_billing[index].key = 3
            state.props.billing_details.default_billing[index].billing_description = state.props.billing_details.default_discount.notes
            state.props.billing_details.default_billing[index].qty = 1
            state.props.billing_details.default_billing[index].unit_price = -state.props.billing_details.default_discount.amount
            state.props.billing_details.default_billing[index].adjustment = 0
            state.props.billing_details.default_billing[index].final_unit_price = -state.props.billing_details.default_discount.amount
            state.props.billing_details.default_billing[index].amount = -state.props.billing_details.default_discount.amount
            state.props.billing_details.default_billing[index].editable = false    
        }

        if(state.props.billing_details.payment_plan == 1) {

            let totalInterest = state.props.billing_details.payment_schedule.forEach(element => {
                if(!isNaN(parseFloat(element.interest))) {
                    totalInterest = totalInterest + parseFloat(element.interest)
                }                
            });

            state.props.billing_details.default_billing.push(JSON.parse(JSON.stringify(default_list_prop)))
            let index = state.props.billing_details.default_billing.length-1
            state.props.billing_details.default_billing[index].key = 4
            state.props.billing_details.default_billing[index].billing_description = 'Interesar'
            state.props.billing_details.default_billing[index].qty = 1
            state.props.billing_details.default_billing[index].unit_price = totalInterest
            state.props.billing_details.default_billing[index].adjustment = 0
            state.props.billing_details.default_billing[index].final_unit_price = totalInterest
            state.props.billing_details.default_billing[index].amount = totalInterest
            state.props.billing_details.default_billing[index].editable = false    
        }
        
}

export const resetEventForm = state => {
    state.props = JSON.parse(JSON.stringify(basicProps))
}

export const setBookedDateList = (state, payload) => {
    state.bookedDateList = payload
}

export const setEventClientInformation = (state, payload) => {
    state.props.client = payload
}

export const setGiftCardValidityInformation = (state, payload) => {
    state.gift_card_redeem.id = payload.id
    state.gift_card_redeem.gift_card_number = payload.gift_card_number
    state.gift_card_redeem.amount = payload.amount
    state.gift_card_redeem.redeemed_amount = payload.redeemed_amount
}

export const resetGiftCardValidityInformation = state => {
    state.gift_card_redeem = {
        id: 0,
        gift_card_number: '',
        amount: 0,
        redeemed_amount: 0
    }
}

export const setGuestList = (state, payload) => {
    let list = payload.dataList    
    if(payload.addType === 'fresh') {        
        state.guests.rawList = list
    } else if(payload.addType === 'push') {
        list.forEach(element => {
            state.guests.rawList.push(element)
        })
    }
}

export const resetGuestListIndex = state => {
    if(state.guests.rawList) {
        let returnList = []
        let companionGuestList = JSON.parse(JSON.stringify(state.guests.rawList)).filter(t => t.parent_guest_id>0)

        state.guests.rawList.filter(t => t.parent_guest_id === 0).forEach(guest => {
            returnList.push(guest)
            companionGuestList.filter(t => t.parent_guest_id === guest.id).sort(function(a, b) {
                return a.guest_name.toLowerCase() > b.guest_name.toLowerCase() ? 1 : -1;
            }).forEach(companion => {
                returnList.push(companion)
            })
        })

        state.guests.list = returnList.sort(function(a, b) {
            return a.guest_name.toLowerCase() > b.guest_name.toLowerCase() ? 1 : -1;
        });
    }
}

export const replaceGuestSingle = (state, payload) => {
    const guestListIndex = state.guests.list.findIndex(t => t.id === payload.id)
    if(guestListIndex >=0) {
        state.guests.list[guestListIndex].guest_name = payload.guest_name
        state.guests.list[guestListIndex].mobile_number = payload.mobile_number
        state.guests.list[guestListIndex].profile_photo = payload.profile_photo
        state.guests.list[guestListIndex].age = payload.age
        state.guests.list[guestListIndex].relation = payload.relation
        state.guests.list[guestListIndex].table_number_id = payload.table_number_id
        state.guests.list[guestListIndex].invitation_status = payload.invitation_status
        state.guests.list[guestListIndex].invitation_confirmation = payload.invitation_confirmation
        state.guests.list[guestListIndex].attend_status = payload.attend_status
        state.guests.list[guestListIndex].attend_time = payload.attend_time
        state.guests.list[guestListIndex].notes = payload.notes
        state.guests.list[guestListIndex].encryption_key = payload.encryption_key
        state.guests.list[guestListIndex].food_preference = payload.food_preference
        state.guests.list[guestListIndex].minor = payload.minor
        state.guests.list[guestListIndex].gender = payload.gender
        state.guests.list[guestListIndex].parent_guest_id = payload.parent_guest_id
        state.guests.list[guestListIndex].allowed_plus_ones = payload.allowed_plus_ones
        state.guests.list[guestListIndex].picture_angle = payload.picture_angle
        state.guests.list[guestListIndex].mobile_prefix = payload.mobile_prefix
        state.guests.list[guestListIndex].table_type = payload.table_type
        state.guests.list[guestListIndex].table_number = payload.table_number
        state.guests.list[guestListIndex].table_label = payload.table_label
        state.guests.list[guestListIndex].parent_guest_name = payload.parent_guest_name
        state.guests.list[guestListIndex].recipe_list = payload.recipe_list
        state.guests.list[guestListIndex].selected = payload.selected
        state.guests.list[guestListIndex].loading = payload.loading
    } else {
        state.guests.list.push(payload)
    }

    resetGuestListIndex(state)
}

export const removeGuestListItem = (state, payload) => {

    const guestListIndex = state.guests.list.findIndex(t => t.id === payload.id)
    if(guestListIndex >=0) {
        state.guests.list.splice(guestListIndex, 1)
    }

}

export const resetGuestDataLoadingStatus = (state, payload) => {
    let filter = state.guests.list.filter(t => t.id == payload.guest_id)
    if(filter.length>0) {
        filter[0].loading = !filter[0].loading
        filter[0].table_number_id = payload.table_id
    }
}
export const setGuestSingle = (state, payload) => {
    state.guests.props = payload
}

export const resetGuestSingle = state => {
    state.guests.props = JSON.parse(JSON.stringify(guestFormProps))
}

export const setTableList = (state, payload) => {
    if(payload.length>0) {
        const distinctTableLabel = payload.filter((thing, index, self) =>
            index === self.findIndex((t) => !(t.id && t.table_number === 0))
        )
        
        state.table_list = payload.filter(t => t.table_number != 0)
        console.log(JSON.stringify(payload))
        const mainTableWithIdIndex = payload.findIndex(t => t.id && t.table_number === 0)
        if(mainTableWithIdIndex>=0) {
            state.table_list.push(payload[mainTableWithIdIndex])
        } else {
            const mainTableWithIdIndex = payload.findIndex(t => !t.id && t.table_number === 0)
            if(mainTableWithIdIndex>=0) {
                payload[mainTableWithIdIndex].table_type = 0        
                state.table_list.push(payload[mainTableWithIdIndex])
            }            
        }
    }
}

export const toggleGuestEditBox = (state, payload) => {
    state.guests.show_guest_window = payload
}

export const setGuestRecipeList = (state, payload) => {
    state.guests.recipe_list = payload   
}

export const setTableClothList = (state, payload) => {
    state.table_cloth_list = payload
}

export const setCakeList = (state, payload) => {
    state.cake_list = payload
}

export const setEventType = (state, payload) => {
    state.event_type = payload
}

export const addNewDayScheduleRow = (state, payload) => {
    state.props.records.day_schedule.push(JSON.parse(JSON.stringify(dayScheduleProps)))
    let index = 0
    state.props.records.day_schedule.forEach(element => {
        element.key = index
        index ++
    })

    function z(n){ return (n<10? '0':'') + n;};
    var bits = payload.time.split(':');
    var mins = bits[0]*60 + +bits[1] + +payload.minsAdd;
    let newTime = z(mins%(24*60)/60 | 0) + ':' + z(mins%60);

    state.props.records.day_schedule[state.props.records.day_schedule.length-1].time_of_action = newTime
//    console.log(newTime)

}

export const removeNewObservationRow = (state, payload) => {
    state.props.records.observations.splice(payload.key, 1)

    if(state.props.records.observations.length === 0) {
        state.props.records.observations.push(JSON.parse(JSON.stringify(observationProps)))
    }
    

    let index = 0
    state.props.records.day_schedule.forEach(element => {
        element.key = index
        index ++
    })
}

export const removeNewDayScheduleRow = (state, payload) => {
    state.props.records.day_schedule.splice(payload.key, 1)

    if(state.props.records.day_schedule.length === 0) {
        state.props.records.day_schedule.push(JSON.parse(JSON.stringify(dayScheduleProps)))
    }
    

    let index = 0
    state.props.records.day_schedule.forEach(element => {
        element.key = index
        index ++
    })
}

export const toggleEventButtonLoading = (state, payload) => {
    state.loading = payload
}

export const setDayScheduleEdit = (state, payload) => {
    state.day_schedule_edit = payload
}

export const setObservationEdit = (state, payload) => {
    state.observation_edit = payload
}

export const setTableLoading = (state, payload) => {
    state.table_loading = payload
}

export const toggleGuestTableNumberId = (state, payload) => {
    state.guests.list.filter(t => t.table_number_id === payload.table_number_id).forEach(el => {
        el.table_number_id = 0
        el.table_number = 0
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/events/mutations.js